@use "styles" as *;

.me-sticky {
  position: relative;
  display: block;

  &__container {
    pointer-events: none;
  }

  &__element {
    position: sticky;
    top: 0;
    z-index: 10100;
    pointer-events: all;
  }
}
